<!-- @veltra/icons generated sha256:58b7bf8d9828b3ad gen:8 source:src/svg/normal/align-center.svg -->
<script setup lang="ts">
defineOptions({ name: 'AlignCenter' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M6 2.506v10.988c0 .276.209.506.485.506h.011c.276 0 .504-.23.504-.506V2.506A.49.49 0 0 0 6.515 2h-.011A.51.51 0 0 0 6 2.506m7 0v10.988c0 .276.209.506.485.506h.011c.276 0 .504-.23.504-.506V2.506A.49.49 0 0 0 13.515 2h-.011a.51.51 0 0 0-.504.506M3.5 11.49V4.509A.51.51 0 0 0 3.004 4a.51.51 0 0 0-.504.51v6.98c0 .277.209.51.485.51h.011a.51.51 0 0 0 .504-.51m7-6.982v6.982a.51.51 0 0 1-.496.509.51.51 0 0 1-.504-.51V4.51A.51.51 0 0 1 9.996 4c.276 0 .504.233.504.51"
    />
  </svg>
</template>
